import { FC } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Control, Controller, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { FormData } from '../constants';
import TimeInputs from './TimeInputs';

type Props = {
	formWatch: FormData;
	control: Control<FormData>;
	errors: FieldErrors<FormData>;
	selectedEditRowRecord: any;
	trigger: UseFormTrigger<FormData>;
	setValue: UseFormSetValue<FormData>;
};

const DefaultInputs: FC<Props> = ({
	formWatch,
	control,
	errors,
	selectedEditRowRecord,
	trigger,
	setValue,
}) => {
	// Switching recurrenceType resets unique form values which are defined in the other input components
	const resetUniqueFormInputs = (): void => {
		setValue('startDate', selectedEditRowRecord?.startDate ?? '');
		setValue('endDate', selectedEditRowRecord?.endDate ?? '');
		setValue('dayOfWeek', selectedEditRowRecord?.dayOfWeek ?? '');
		setValue('includeWeekends', selectedEditRowRecord?.includeWeekends ?? false);
		setValue('dayOfMonth', selectedEditRowRecord?.dayOfMonth ?? '');
		setValue('month', selectedEditRowRecord?.month ?? '');
	};
	return (
		<>
			{/* Inputs used by all form layouts */}
			<Controller
				name="recurrenceType"
				control={control}
				render={() => (
					<FormControl fullWidth>
						<InputLabel id="recurrence-label">Recurrence</InputLabel>
						<Select
							labelId="recurrence-label"
							id="recurrence"
							value={formWatch.recurrenceType}
							label="Recurrence"
							onChange={(evt) => {
								setValue('recurrenceType', evt.target.value, { shouldValidate: true });
								resetUniqueFormInputs();
							}}
							sx={{ marginBottom: '1rem' }}
							error={!!errors.recurrenceType}
						>
							<MenuItem value={'SINGLE'}>SINGLE</MenuItem>
							<MenuItem value={'DAILY'}>DAILY</MenuItem>
							<MenuItem value={'WEEKLY'}>WEEKLY</MenuItem>
							<MenuItem value={'MONTHLY'}>MONTHLY</MenuItem>
							<MenuItem value={'YEARLY'}>YEARLY</MenuItem>
						</Select>
					</FormControl>
				)}
			/>
			{formWatch.recurrenceType ? (
				<Box>
					<Controller
						name="description"
						control={control}
						render={({ field }) => (
							<TextField
								{...field}
								id="description"
								name="description"
								label="Description"
								value={formWatch.description}
								type="text"
								fullWidth
								variant="outlined"
								sx={{ marginBottom: '1rem' }}
								error={!!errors.description}
								helperText={errors.description?.message}
							/>
						)}
					/>
					<TimeInputs
						formWatch={formWatch}
						control={control}
						errors={errors}
						trigger={trigger}
						setValue={setValue}
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default DefaultInputs;
